import React from "react"
import Product from "../Components/Product"

export default ({ products, className, row = true, productClassName, show, hide, shouldShowMiniCartOnAdd, productBreakpoints }) => {
    return <ul className={`${row ? 'row' : ''} product-list ${className ? className : ""}`}>
        {products.map(product => <Product {...product} columns={productBreakpoints} show={show} hide={hide} className={productClassName} key={product.id} shouldShowMiniCartOnAdd={shouldShowMiniCartOnAdd} />)}
    </ul>
}